import { useContext } from 'react';
import { PortalAuthContext, type AuthState } from '../contexts/AuthContext';

export function useAuth(): AuthState {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
